
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.745 9.45L13.368 1.12a.623.623 0 00-.736 0L1.255 9.45a.624.624 0 10.737 1.006L13 2.396l11.008 8.06a.62.62 0 00.872-.134.624.624 0 00-.135-.872z","fill":"#989AB3","stroke":"#989AB3","stroke-width":".4"}}),_c('path',{attrs:{"d":"M21.73 10.598a.624.624 0 00-.623.623v9.926h-4.989v-5.418A3.122 3.122 0 0013 12.61a3.122 3.122 0 00-3.118 3.118v5.418H4.894V11.22a.624.624 0 00-1.248 0v10.55c0 .344.28.623.624.623h6.236a.623.623 0 00.623-.623v-6.042c0-1.032.84-1.871 1.871-1.871 1.032 0 1.871.84 1.871 1.87v6.042a.623.623 0 00.624.623h6.235c.345.001.624-.278.624-.623V11.221a.624.624 0 00-.623-.623z","fill":"#989AB3","stroke":"#989AB3","stroke-width":".4"}})])
          )
        }
      }
    